export const publicRoutes = ['login', 'reset-password', 'forgot-password']

export function routeIsPublic(path) {
  return publicRoutes.includes(path)
}
